import React from 'react';
import {
    View,
    FlatList,
    StyleSheet,
} from 'react-native';
import { useCurrentTheme } from "@/theming/useCurrentTheme";
import { ThemeType } from "@/theming/baseTheme";
import MediaCard from "@/components/media/MediaCard";
import { SectionHeader } from "@/components/organization/SectionHeader";
import {AppDataMediaItem} from "@/data/app-data-interfaces";

interface HorizontalVideoListProps {
    videos: AppDataMediaItem[];
    title: string;
    actionText?: string;
    onActionPress?: () => void;
    onPlayVideo: (videoId: string) => void;
}

export const HorizontalVideoListComponent: React.FC<HorizontalVideoListProps> = ({
                                                                                     videos,
                                                                                     title,
                                                                                     actionText,
                                                                                     onActionPress,
                                                                                     onPlayVideo,
                                                                                 }) => {
    const { theme } = useCurrentTheme();
    const styles = createStyles(theme);

    if (videos.length === 0) {
        return null;
    }

    return (
        <View style={styles.container}>
            <SectionHeader
                title={title}
                actionText={actionText}
                onActionPress={onActionPress}
            />
            <FlatList
                data={videos}
                renderItem={({ item }) => <MediaCard item={item} onPressed={onPlayVideo} />}
                keyExtractor={(item) => item.id}
                horizontal
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={styles.videosScroll}
                ItemSeparatorComponent={() => <View style={{ width: theme.spacing.md }} />}
            />
        </View>
    );
};

const createStyles = (theme: ThemeType) => StyleSheet.create({
    container: {
        paddingVertical: theme.spacing.lg,
    },
    videosScroll: {
        paddingHorizontal: theme.spacing.lg,
    },
});
